import { render, staticRenderFns } from "./c_Creator_EditQuests_Item_BodyMap.vue?vue&type=template&id=6e1292e6&scoped=true&"
import script from "./c_Creator_EditQuests_Item_BodyMap.vue?vue&type=script&lang=js&"
export * from "./c_Creator_EditQuests_Item_BodyMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1292e6",
  null
  
)

export default component.exports